import { motion } from "framer-motion";
import { useEffect, useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.08, duration: 0.6, ease: "easeOut" },
  }),
};

export default function FeaturesPage() {
  const { t, isRTL } = useContext(LanguageContext);
  const items = t("featuresPage.items", { returnObjects: true });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <section
      dir={isRTL ? "rtl" : "ltr"}
      className="relative bg-white py-24 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-gray-50 via-white to-white" />

      <div className="mx-auto max-w-7xl px-6">

        {/* Header */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          className="mb-20 text-center"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
            {t("featuresPage.hero.title")}
          </h1>
          <p className="mt-6 max-w-3xl mx-auto text-lg text-gray-600">
            {t("featuresPage.hero.subtitle")}
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((feature, i) => (
            <motion.div
              key={i}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeUp}
              className="rounded-2xl border bg-white p-8 shadow-sm hover:shadow-md transition"
            >
              <h3 className="text-xl font-semibold mb-3 text-gray-900 hover:text-rose-600 transition">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.desc}
              </p>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          className="mt-28 rounded-3xl bg-gray-900 p-12 text-center text-white"
        >
          <h2 className="text-3xl font-semibold mb-4">
            {t("featuresPage.cta.title")}
          </h2>
          <p className="mb-6 text-gray-300">
            {t("featuresPage.cta.text")}
          </p>
          <a
            href="/contact"
            className="inline-flex rounded-xl bg-rose-600 px-8 py-3 font-medium text-white hover:bg-rose-700 transition"
          >
            {t("featuresPage.cta.button")}
          </a>
        </motion.div>

      </div>
    </section>
  );
}
